import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { formatRut } from "../lib/format";

// Pantalla pública (ruta "/"): acceso de apoderados por enlace mágico.
// No expone ninguna opción de administración.
export function LoginApoderado() {
  const { requestMagicLink } = useAuth();
  const [rut, setRut] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await requestMagicLink(rut, email);
      setSent(true);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center bg-gradient-to-br from-brand-50 via-slate-50 to-white p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 grid h-14 w-14 place-items-center rounded-2xl bg-brand-600 text-2xl">
            🏐
          </div>
          <h1 className="text-2xl font-extrabold text-slate-800">Portal de apoderados</h1>
          <p className="text-sm text-slate-500">Consulta las cuotas y pagos de tu hijo/a</p>
        </div>

        <div className="card p-6">
          {sent ? (
            <div className="space-y-3 text-center">
              <div className="mx-auto grid h-12 w-12 place-items-center rounded-full bg-emerald-100 text-2xl">
                📧
              </div>
              <h2 className="font-bold text-slate-800">Revisa tu correo</h2>
              <p className="text-sm text-slate-500">
                Si los datos son correctos, te enviamos un enlace de acceso a <b>{email}</b>.
                Vence en 15 minutos y es de un solo uso.
              </p>
              <button className="btn-ghost w-full" onClick={() => { setSent(false); setError(""); }}>
                Usar otro RUT o correo
              </button>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="label">RUT del alumno</label>
                <input
                  className="input"
                  placeholder="12.345.678-9"
                  value={rut}
                  onChange={(e) => setRut(formatRut(e.target.value))}
                  required
                />
              </div>
              <div>
                <label className="label">Tu correo (apoderado)</label>
                <input
                  className="input"
                  type="email"
                  placeholder="correo@mail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {error && (
                <p className="rounded-lg bg-rose-50 px-3 py-2 text-sm text-rose-600">{error}</p>
              )}

              <button className="btn-primary w-full" disabled={busy}>
                {busy ? "Enviando enlace…" : "Enviarme el enlace de acceso"}
              </button>
              <p className="text-center text-xs text-slate-400">
                No necesitas contraseña. Te enviamos un enlace seguro al correo que registraste.
              </p>
            </form>
          )}

          <div className="mt-5 border-t border-slate-100 pt-4 text-center">
            <p className="text-sm text-slate-500">¿Primera vez o aún no registras tu correo?</p>
            <Link to="/activar" className="btn-ghost mt-2 w-full">Activar mi cuenta</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
